__turbopack_context__.v({
  "button": "IFDfyq_button",
  "imageContainer": "IFDfyq_imageContainer",
  "infoModalContainer": "IFDfyq_infoModalContainer",
  "infoModalDescription": "IFDfyq_infoModalDescription",
  "infoModalTitle": "IFDfyq_infoModalTitle",
  "pricingModal": "IFDfyq_pricingModal",
});
